import { render, staticRenderFns } from "./GlobalBack.vue?vue&type=template&id=abd31a6c&scoped=true"
import script from "./GlobalBack.vue?vue&type=script&lang=js"
export * from "./GlobalBack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abd31a6c",
  null
  
)

export default component.exports